import { useLocation, useSearchParams } from "react-router-dom";

/** 放在地址栏查询串里的筛选条件：刷新页面、从详情返回都还在。keys 是参数名，没有的值为空串；set 空串就是去掉这个条件，clear 一次清空全部。
 * 要同时改几个条件用 update：连着调两次 set，后一次会盖掉前一次。
 * 改条件是替换当前历史记录，带上原来的 state（详情页靠它记着返回列表时的条件）。 */
export function useSearchFilters<K extends string>(keys: readonly K[]) {
  const [params, setParams] = useSearchParams();
  const { state } = useLocation();
  const filters = Object.fromEntries(keys.map((k) => [k, params.get(k) ?? ""])) as Record<K, string>;
  const update = (patch: Partial<Record<K, string>>) => setParams((prev) => {
    const next = new URLSearchParams(prev);
    for (const [k, v] of Object.entries(patch) as [K, string][]) {
      if (v) next.set(k, v);
      else next.delete(k);
    }
    return next;
  }, { replace: true, state });
  const set = (key: K, value: string) => update({ [key]: value } as Partial<Record<K, string>>);
  const clear = () => setParams((prev) => {
    const next = new URLSearchParams(prev);
    keys.forEach((k) => next.delete(k));
    return next;
  }, { replace: true, state });
  return { filters, set, update, clear, active: keys.some((k) => filters[k] !== "") };
}
